
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.318 11.868a1 1 0 00-1.612 1.184l3.902 5.312a1 1 0 001.592.026l9.074-11.544A1 1 0 1017.7 5.61L9.44 16.12l-3.123-4.252z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    